define("shared/components/shared/button/copy", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.shouldShowCopyButton}}
    <Shared::Ui::Button
      @isDisabled={{this.isDisabled}}
      @onClick={{this.toggleCopyModal}}
      @variant="outline"
      class={{concat-classes
        "u--float--left u--m__l__xs qa--modal_copy_button"
        (if this.isDraft "qa--modal_copyDraft_btn" "qa--modal_copyPost_btn")
      }}
      data-test-id="post-footer-copy-button"
    >
      {{svg-jar "copy" class="o--icon u--m__r__xs"}}
      {{t (if this.isDraft "post.footer.copy_draft" "post.footer.copy_post")}}
    </Shared::Ui::Button>
  {{/if}}
  */
  {
    "id": "+y/voBYR",
    "block": "[[[41,[30,0,[\"shouldShowCopyButton\"]],[[[1,\"  \"],[8,[39,1],[[16,0,[28,[37,2],[\"u--float--left u--m__l__xs qa--modal_copy_button\",[52,[30,0,[\"isDraft\"]],\"qa--modal_copyDraft_btn\",\"qa--modal_copyPost_btn\"]],null]],[24,\"data-test-id\",\"post-footer-copy-button\"]],[[\"@isDisabled\",\"@onClick\",\"@variant\"],[[30,0,[\"isDisabled\"]],[30,0,[\"toggleCopyModal\"]],\"outline\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,3],[\"copy\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n    \"],[1,[28,[35,4],[[52,[30,0,[\"isDraft\"]],\"post.footer.copy_draft\",\"post.footer.copy_post\"]],null]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"shared/ui/button\",\"concat-classes\",\"svg-jar\",\"t\"]]",
    "moduleName": "shared/components/shared/button/copy.hbs",
    "isStrictMode": false
  });
  let PostFooterButtonCopyComponent = _exports.default = (_class = class PostFooterButtonCopyComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
    }
    get isDraft() {
      return Boolean(this.args.post?.isDraft);
    }
    get shouldShowCopyButton() {
      const {
        post
      } = this.args;
      if (post) {
        return !post.get('isNew') || post.isPosted;
      }
      return false;
    }
    get isDisabled() {
      return Boolean(this.args.validator?.hasError);
    }
    async toggleCopyModal() {
      if (this.args.isDirty) {
        const didConfirm = await this.dialogManager.confirmation(this.intl.t('post.copy_post.confirm.title'), {
          description: this.intl.t('post.copy_post.confirm.description'),
          confirmButton: this.intl.t('post.copy_post.confirm.confirm'),
          confirmButtonClass: 'qa--modal_confirm_btn',
          cancelButtonClass: 'qa--modal_cancel_btn'
        });
        if (!didConfirm) {
          return;
        }
        try {
          await this.args.savePost.perform();
        } catch (error) {
          this.errors.log('Error saving post for copy', error);
          this.alerts.warning(this.intl.t('alerts.generic_error_message'));
          return;
        }
      }
      this.args.toggleCopyPostModal();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "toggleCopyModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCopyModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PostFooterButtonCopyComponent);
});